import { RootState } from '../../reducers';

export const getAutomatedReports = (state: RootState) => state.entities.automatedReports;
